<template>
  <div>
        <el-tabs v-model="active_tab">
            <el-tab-pane label="Summary" name="1">
                <Summary 
                    @addTask="addTask"                    
                    :calendar_view="calendar_view"
                    @loadCustomerInvoiceList="loadCustomerInvoiceList" 
                    @navigateMasterProductionQuery="navigateMasterProductionQuery" 
                    :data_list="data_list" 
                    :searchType="searchType"/>
            </el-tab-pane>
            <el-tab-pane 
                v-for="(data, index) in getCategoryWiseList"
                :key="index"
                :label="data.category_name" 
                v-if="data.item_list.reduce((count, element1) => {return count + parseInt(element1.item_list.length);}, 0)>0" :name="(index+2)+''">

                    <div style="text-align: right; width: 100%; display: flex; flex-direction: row; justify-content: flex-end;">
                        <el-select 
                            size="small"
                            placeholder="Filter by store"
                            v-model="store_id" 
                            filterable 
                            style="width: 250px; text-align: left;">
                            <el-option :value="0" :label="'All Stores'">
                                <span style="float: left" v-html="'All Stores'"></span>
                            </el-option>
                            <el-option
                                v-for="(data, index) in $store.getters.getAccessibleStoreList"
                                :key="index"
                                :label="data.store_name"
                                :value="data.id">
                                <span style="float: left" v-html="data.store_name"></span>
                            </el-option>
                        </el-select>

                       <!-- <el-button v-if="!calendar_view" size="small" @click="updateAllPromises" :loading="processing" style="margin-right: 10px;">
                            Update All Promises
                        </el-button>-->

                        <el-button 
                            size="small" 
                            type="primary" 
                            @click="downloadItemCSVList(data.item_list)" 
                            style="margin-left: 10px;">
                            Download CSV
                        </el-button>
                    </div>
                    <br>
                   <el-tabs v-if="active_tab == (index+2)+''" :tab-position="'left'" v-model="sub_active_tab" type="border-card">
                        <el-tab-pane :name="'all_process'" :label="'All Items'">
                            <ProcessList 
                                v-if="sub_active_tab == 'all_process'"
                                @addTask="addTask"
                                :store_id="getStoreId" 
                                :searchType="searchType" 
                                :calendar_view="calendar_view"
                                :all_list="true"
                                :data_list="getCategoryWiseAllItem.filter(t => getStoreId > 0 ? t.store_id === getStoreId : t.store_id>0)"/>
                        </el-tab-pane>
                        
                        <el-tab-pane 
                            v-for="(data1, index_1) in data.item_list"
                            :key="index_1+'_sub'"
                            :name="(index_1+1)+''"
                            v-if="data1.item_list.filter(t => getStoreId > 0 ? t.store_id === getStoreId : t.store_id>0).length>0"
                            :label="data1.process_name+' ('+data1.item_list.filter(t => getStoreId > 0 ? t.store_id === getStoreId : t.store_id>0).length+')'">
                            <ProcessList 
                                v-if="sub_active_tab == (index_1+1)+''"
                                @addTask="addTask"
                                :store_id="getStoreId" 
                                :searchType="searchType" 
                                :calendar_view="calendar_view"
                                :data_list="data1.item_list.filter(t => getStoreId > 0 ? t.store_id === getStoreId : t.store_id>0)"/>
                        </el-tab-pane>                   
                    </el-tabs>
                    
            </el-tab-pane>
        </el-tabs>
        
  </div>
</template>

<script>
import Summary from './Summary.vue'
import ProcessList from './ProcessList/Index.vue'

export default {
    components: {Summary, ProcessList},
    props: ['data_list', 'searchType', 'calendar_view'],
    data() {
      return {
        active_tab: "1",
        sub_active_tab: "1",
        store_id: null,
        item_list: [],
        display_window: false
      }
    },
    methods: {
        addTask($event) {
            this.$emit('addTask', $event)
        },
        loadCustomerInvoiceList($event) {
            this.$emit('loadCustomerInvoiceList', $event)
        },
        navigateMasterProductionQuery($event) {
            this.$emit('navigateMasterProductionQuery', $event)
        },
        downloadItemCSVList(masterItemList) {

            if(masterItemList) {
                masterItemList.forEach(item => {

                    item.item_list.filter(t => this.getStoreId > 0 ? t.store_id === this.getStoreId : t.store_id>0).forEach(item1 => {
                        this.item_list.push(item1)
                    })

                })
                this.$store.dispatch('downloadCSV', {data: this.getCSVItemList, title: 'All_Item_Promises'})
            }
            
        }
    },
    computed: {
        getCSVItemList() {
            
            let dataList = [];
            this.item_list.forEach(element => {
                dataList.push(element)
            })

            let data = []

            let returnData = {
                wo_number: 'WO#',
                promise_date: 'Promise Date',
                customer: 'Customer',
                category: 'Category Name',
                sub_category: 'Sub-Category',
                garment_name: 'Garment',
                process_name: 'Current Process',
                status: 'work_order_status'
            }

            data.push(returnData)
            const allItemCategoryList = this.$store.getters.getAllItemCategoryList

            dataList.forEach(element => {

                const subCategoryIndex = allItemCategoryList.findIndex(t => t.id === element.sub_category_id)

                let returnData = {
                    wo_number: element.work_order_number,
                    promise_date: element.appointment_date,
                    customer: element.customer_name,
                    category: element.category_name,
                    sub_category: subCategoryIndex>=0 ? allItemCategoryList[subCategoryIndex].sub_category_name : '',
                    garment_name: element.template_name,
                    process_name: element.process_name,
                    status: element.work_order_status
                }

                data.push(returnData)

            })
            return data
            
        },
        getStoreId() {
            return this.store_id
        },
        getCategoryWiseList() {
            let list = []

            this.$store.getters.getItemCategoryList.forEach(category => {

                let procsessWiseList = []

                this.$store.getters.getProductionStageList.forEach(process => {

                    let itemList = this.data_list.filter(t => t.category_id == category.id || (t.sub_template_category_id !== null && t.sub_template_category_id == category.id))
                    procsessWiseList.push({
                        process_id: process.id,
                        process_name: process.process_name,
                        item_list: itemList.filter(t => t.process_id == process.id)
                    })
                })

                list.push({
                    category_id: category.id,
                    category_name: category.category_name,
                    item_list: procsessWiseList
                })
            })

            return list
        },
        getCategoryWiseAllItem() {

            let list = []

            this.$store.getters.getItemCategoryList.forEach(category => {

                let itemList = this.data_list.filter(t => t.category_id == category.id || (t.sub_template_category_id !== null && t.sub_template_category_id == category.id))
                
                itemList.forEach(element => {
                    list.push(element)
                })

            })

            return list

        }
    },
    mounted() {
        setTimeout(() => {
            this.display_window = true
        }, 3000);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Planner/CustomerList/Index.vue